import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as D from '../../../deps';
import { BackstageTrackListItem } from '../../BackstageTrackListItem';

// @ts-expect-error TS(7006) FIXME: Parameter 'trackProps' implicitly has an 'any' typ... Remove this comment to see the full error message
const mapPropsToTrackListItem = (trackProps, isCompilation, albumPandoraId) => {
  return {
    pandoraId: get(trackProps, 'id', null),
    playIndex: get(trackProps, 'trackNumber', null) - 1,
    trackName: get(trackProps, 'name', ''),
    trackUrl: get(trackProps, 'url', null),
    trackDuration: D.formatTime(get(trackProps, 'duration', null)),
    isClean:
      get(trackProps, 'explicitness', null) ===
      D.getInDomain('catalog.constants.Explicitness.CLEAN'),
    isExplicit:
      get(trackProps, 'explicitness', null) ===
      D.getInDomain('catalog.constants.Explicitness.EXPLICIT'),
    isUnavailable:
      !get(trackProps, 'rights.hasInteractive', false) &&
      !get(trackProps, 'rights.hasRadioRights', true),
    isRadioOnly:
      !get(trackProps, 'rights.hasInteractive', false) &&
      get(trackProps, 'rights.hasRadioRights', false),
    rowNumber: get(trackProps, 'trackNumber', null),
    secondText: isCompilation ? get(trackProps, 'artist.name', null) : null,
    secondTextUrl: isCompilation ? get(trackProps, 'artist.url', null) : null,
    playablePandoraId: albumPandoraId,
    hasBorderTopBottom: true,
    isAlbumBSP: true,
  };
};

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const AlbumTrackListItem = props => {
  const { trackProps, isCompilation, albumPandoraId, ...restProps } = props;

  const mappedProps = mapPropsToTrackListItem(trackProps, isCompilation, albumPandoraId);

  const BackstageTrackListItemProps = {
    ...mappedProps,
    ...restProps,
  };

  return <BackstageTrackListItem {...BackstageTrackListItemProps} />;
};

AlbumTrackListItem.propTypes = {
  trackProps: PropTypes.object,
  isCompilation: PropTypes.bool,
  albumPandoraId: PropTypes.bool,
  releaseType: PropTypes.string,
};

// @ts-expect-error TS(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
export function mapStateToProps(state, ownProps) {
  const { trackProps, albumPandoraId, releaseType } = ownProps;
  const trackPandoraId = get(trackProps, 'id', null);

  const isPlayingCurrently = D.getInDomain('playback.utils.isTrackPlayingCurrently', false)(
    state,
    trackPandoraId,
  );
  const isAudioPlaying = D.getInDomain('playback.utils.isAudioPlaying', false)(state);

  const isSingleRelease = releaseType === D.getInDomain('catalog.constants.ReleaseType.SINGLE');
  const isEpRelease = releaseType === D.getInDomain('catalog.constants.ReleaseType.EP');
  const isShortReleaseType = isSingleRelease || isEpRelease;

  const isAlbumCollected = D.getInDomain('collection.utils.isPandoraIdInCollection', false)(
    state,
    albumPandoraId,
  );
  const sourceCardAlbumId = isAlbumCollected || isShortReleaseType ? albumPandoraId : null;
  const sourceCardMenuItems = D.getSourceCardMenuItems({
    state,
    pandoraId: trackPandoraId,
    pandoraType: D.PandoraTypes.SONG,
    shareParentSource: {
      shareParentSourceId: albumPandoraId,
      shareParentSourceType: D.PandoraTypes.ALBUM,
    },
    albumId: sourceCardAlbumId,
  });

  return {
    isPlaying: isPlayingCurrently && isAudioPlaying,
    isPaused: isPlayingCurrently && !isAudioPlaying,
    isMobileWeb: D.isMobileWeb(state),
    sourceCardMenuItems,
    isCollected: D.getInDomain('collection.utils.isPandoraIdInCollection', false)(
      state,
      trackPandoraId,
    ),
  };
}

const mapDispatchToProps = {
  pauseTrack: D.Actions.UseCases.pauseTrack,
  playResumeSource: D.playResumeSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumTrackListItem);
